import React from 'react';
import { IconButton, Stack, type SxProps, type Theme } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';

import { useColorMode, type ColorModePreference } from '../GridlineProvider';

const MODE_OPTIONS: Array<{
  value: ColorModePreference;
  label: string;
  icon: React.ReactElement;
}> = [
  { value: 'light', label: 'Light', icon: <LightModeOutlinedIcon sx={{ fontSize: 18 }} /> },
  { value: 'dark', label: 'Dark', icon: <DarkModeOutlinedIcon sx={{ fontSize: 18 }} /> },
  { value: 'system', label: 'System', icon: <SettingsBrightnessOutlinedIcon sx={{ fontSize: 18 }} /> },
];

interface ThemeModeSelectProps {
  sx?: SxProps<Theme>;
}

export function ThemeModeSelect({ sx }: ThemeModeSelectProps) {
  const { mode, setMode } = useColorMode();

  return (
    <Stack direction="row" spacing={0.5} role="group" aria-label="Appearance" sx={sx}>
      {MODE_OPTIONS.map((option) => {
        const selected = mode === option.value;
        return (
          <IconButton
            key={option.value}
            size="small"
            aria-label={option.label}
            aria-pressed={selected}
            onClick={() => setMode(option.value)}
            sx={{
              borderRadius: 1,
              border: '1px solid',
              borderColor: selected ? 'primary.main' : 'divider',
              bgcolor: selected ? 'primary.main' : 'transparent',
              color: selected ? 'primary.contrastText' : 'text.secondary',
              '&:hover': {
                bgcolor: selected ? 'primary.dark' : 'action.hover',
              },
            }}
          >
            {option.icon}
          </IconButton>
        );
      })}
    </Stack>
  );
}
